import api from "../axiosIntercepture";

export const saveChannel=async(channelData)=>{
try{
    // console.log(channelData,"channelData");
    
const response = await api.post('/ordermanagement/createChannel',channelData);
return response;
}
catch(err){   
 throw err?.response;
}
}

export const getChannel = async()=>{
    try{
        const response = await api.post('/ordermanagement/getChannel');
        return response.data?.data
    }
    catch(err){
        throw err?.response?.data?.message
    }
}

export const updateChannel = async(data,id)=>{
    try{
        const response = await api.post(`/ordermanagement/updateChannel/${id} `,data);
        return response;
    }
    catch(err){
        throw err?.response;
    }
}


export const getChannelType = async()=>{
    try{
        const response = await api.get('/ordermanagement/getChannelType');
        return response;
    }
    catch(err){
        throw err?.response
    }
}

